import { useCallback, useEffect, useState } from "react";
import { Package } from "lucide-react";
import { api, apiError, brl, fileUrl } from "@/lib/api";
import { EmptyState, ErrorState, Loading, Surface, Thumb } from "@/components/ds";

export function FinishedGoodsPanel() {
  const [products, setProducts] = useState(null);
  const [error, setError] = useState("");

  const load = useCallback(async () => {
    setError("");
    try {
      const { data } = await api.get("/products");
      setProducts(data);
    } catch (e) {
      setError(apiError(e));
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  if (error) return <ErrorState message={error} onRetry={load} />;
  if (!products) return <Loading label="Carregando produtos acabados..." />;
  if (products.length === 0)
    return (
      <EmptyState
        icon={Package}
        title="Nenhum produto cadastrado"
        description="Os produtos acabados aparecem aqui conforme as produções são concluídas."
      />
    );

  const total = products.reduce((s, p) => s + Number(p.stock_units || 0), 0);

  return (
    <div className="space-y-6" data-testid="finished-goods-panel">
      <p className="text-sm text-muted-foreground">
        Produto acabado é o que entra no estoque quando a produção é concluída.{" "}
        <span className="text-foreground">
          {total.toLocaleString("pt-BR")} un no total
        </span>{" "}
        — movimente cada item na tela de Produtos.
      </p>
      <Surface className="divide-y divide-white/5">
        {products.map((p) => (
          <div key={p.id} className="flex items-center gap-4 p-4" data-testid={`finished-row-${p.id}`}>
            <Thumb src={fileUrl(p.photo_path)} alt={p.name} className="h-11 w-11" fallback={<Package className="h-4 w-4 opacity-70" />} />
            <div className="min-w-0 flex-1">
              <p className="truncate text-sm font-medium">{p.name}</p>
              <p className="truncate text-xs text-muted-foreground">
                {[p.code, p.category].filter(Boolean).join(" · ") || "Sem código"} · preço {brl(p.price)}
              </p>
            </div>
            <span className="font-num text-sm" data-testid={`finished-qty-${p.id}`}>
              {Number(p.stock_units || 0).toLocaleString("pt-BR")} un
            </span>
          </div>
        ))}
      </Surface>
    </div>
  );
}
